export default __webpack_public_path__ + "static/media/nim.318cecca.jpg";